import ReactHtmlParser from 'react-html-parser';

/**
 * Formats a number into human-readable currency string.
 * @param {number} value - the numeric dollar amount
 * @param {string} lang - the locale, used to format the end result (en or fr)
 * @param {number} digits - the number of digits to show after the dollar amount
 * @returns A formatted currency string.
 */
const formatCurrency = (value = 0, lang = 'en', digits = 2) => {
  const separator = lang === 'fr' ? ' ' : ',';
  const prefix = lang === 'fr' ? '' : '$';
  const postfix = lang === 'fr' ? ReactHtmlParser('&nbsp;$') : '';

  // Format dollars without using regex by converting to an array and adding separators
  const formatDollars = (num) => {
    const str = Math.floor(Math.abs(num)).toString();
    let result = '';
    for (let i = str.length - 1, count = 0; i >= 0; i--, count++) {
      if (count > 0 && count % 3 === 0) result = separator + result;
      result = str[i] + result;
    }
    return result;
  };

  const dollars = formatDollars(value);

  if (!digits) return `${prefix}${dollars}${postfix}`;

  const cents = (+value % 1).toFixed(digits).substring(2); // Extract the cents without regex
  const delimiter = lang === 'fr' ? ',' : '.';

  return `${prefix}${dollars}${delimiter}${cents}${postfix}`;
};

export default formatCurrency;
